import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.planning')
  .factory('$planningProjects', planningProjectsObjectFactory);

/* @ngInject */
function planningProjectsObjectFactory($bringozFactory: $bringozFactory,
                                       PlanningProjectsAPI: BringozApi,
                                       Planning_Projects_DS: DataStoreConfig,
                                       PlanningProjects_PN: PushNotificationsConfig) {

  function $planningProjects(id: string) {
    return $bringozFactory(id, PlanningProjectsAPI, Planning_Projects_DS, PlanningProjects_PN)
  }

  return $planningProjects
}
